import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { I18n } from "@aws-amplify/core";
import { withRouter } from "react-router-dom";
import { get } from "lodash";
import Grid from "@material-ui/core/Grid";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox'

import { fetchPut } from "../../api/fetch";
import CustomSelect from "../Common/CustomSelect";
import TrainInfoDisplay from "./TrainInfoDisplay";
import TrainCarousel from "./TrainCarousel";
import RailcarIcon from "./RailcarIcon";
import EventsDialog from "../Events/EventsDialog";
import CsvExportDialog from "../Common/CsvExportDialog";
import { generateDate, minifyRailcar, returnRailcarName, isRailcarVisible } from "./HelperFunctions";
import { updateSelectedRailcarId } from "../../actions/siteEntranceExit/tabs";
import { ReactComponent as CompareManifest } from "./assets/compare-match-icon.svg";
import CloseIcon from "../Common/CloseIcon";
import images from "../../assets/img/images";
import { getLov, getOptionsFromLov } from "../../utils/lov";
import { unknownProfiles } from "../../utils/profile";
import { updateOneLog } from "../../actions/siteEntranceExit/tabs";

const trainColumns = {
  ref: "10%",
  date: "10%",
  id: "15%",
  railway: "15%",
  event: "10%",
  direction: "10%",
  locomotives: "10%",
  wagons: "10%",
  containers: "10%",
}

const styles = {
  tabContainer: {
    marginTop: "20px",
    marginLeft: "20px",
  },
  carouselContainer: {
    height: "900px",
    padding: "24px",
    maxWidth: "calc(100% - 16px)",
    display: "flex",
    flexDirection: "row",
  },
  trainTrackContainer: {
    display: "flex",
    flexDirection: "column",
  },
  dataSidebar: {
    display: "flex",
    flexDirection: "column",
    width: "200px",
  },
  dataItem: {
    display: "flex",
    flexDirection: "column",
    marginBottom: "16px",
  },
  black54: {
    color: "rgba(0,0,0,0.54)",
  },
  trainDisplayPanels: {
    width: "calc(100%-80px)",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    padding: "16px 0px 0px 0px"
  },
  trainTrackingStatus: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between"
  },
  railcarDataTable: {
    display: "flex",
    alignItems: "flex-end",
    paddingTop: "4px"
  },
  rcColumn: {
    display: "flex",
    flexDirection: "column",
    borderLeft: "1px solid #EFEFEF",
    borderTop: "1px solid #EFEFEF",
  },
  rcColumnSpecial: {
    marginLeft: "16px"
  },
  rcEntry: {
    width: "85px",
    textAlign: "center",
    padding: "0px 4px",
    borderBottom: "1px solid #EFEFEF",
  },
  actionText: {
    color: "#5f00a0",
    fontWeight: "500",
    cursor: "pointer",
  },
  disabledText: {
    color: "gray",
    pointerEvents: "none"
  },
  rcLastCol: {
    backgroundColor: "#EFEFEF",
    height: "144px",
    width: "1px",
  },
  headerRow: {
    borderBottom: "1px solid #EFEFEF",
    backgroundColor: "white",
    width: "110px",
    paddingLeft: "8px",
  },
  headerRowTotal: {
    height: "80px",
    width: "160px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    borderBottom: "1px solid #EFEFEF",
  },
  tableToggle: {
    paddingLeft: "140px",
    display: "flex",
  },
  selectionOption: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
  },
  headerColumn: {
    height: "80px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  railcarName: {
    fontSize: "12px",
    color: "black",
    fontWeight: "500"
  },
  headerColTotal: {
    borderBottom: "1px solid #EFEFEF",
    backgroundColor: "#DEDEDE",
    width: "50px",
    textAlign: "center",
  },
  selectedFilter: {
    backgroundColor: "orange",
    color: "white"
  },
  matchFilter: {
    backgroundColor: "orange",
    color: "white"
  },
  trainSvgIcon: {
    width: "85%",
    height: "30px",
  },
  showAll: {
    fontWeight: "500",
    cursor: "pointer"
  },
  trainTrackingInfo: {
    display: "flex",
    "& div": {
      paddingRight: "16px",
    }
  },
  trainTable: {
    margin: "24px 0 0 0px",
    padding: "24px",
    borderRadius: "4px 4px 0px 0px",
    width: "calc(100% - 48px)",
    height: "276px",
  },
  tableMainContainer: {
    height: "100%",
    maxWidth: "1735px",
  },
  tableWrapper: {
    width: "100%",
    height: "100%",
    overflow: "auto",
    "& table": {
      borderCollapse: "separate",
      tableLayout: "fixed",
    },
    "& table thead tr": {
      backgroundColor: "white",
      height: "50px"
    },
    "& table thead tr th": {
      backgroundColor: "#e5f4f6",
      position: "sticky",
      top: "0px",
      zIndex: "1",
    },
    "& table thead tr th:not(:last-child)": {
      borderRight: "3px solid white",
      backgroundClip: "padding-box",
      boxSizing: "border-box",
    },
    "& table tbody tr td": {
      height: "50px",
      color: "rgba(0, 0, 0, 0.54)",
      paddingLeft: "12px",
      cursor: "pointer",
    },
  },
  tableSubtitle: {
    width: "100%",
    padding: "0 12px",
    textAlign: "left",
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
  },
  tableElement: {
    width: `calc(${trainColumns.ref} + ${trainColumns.date} + ${trainColumns.id} + ${trainColumns.railway} + ${trainColumns.event} + ${trainColumns.direction} + ${trainColumns.locomotives} + ${trainColumns.wagons} + ${trainColumns.containers})`,
  },
  tableRef: {
    width: trainColumns.ref,
  },
  tableDate: {
    width: trainColumns.date,
  },
  tableId: {
    width: trainColumns.id,
  },
  tableRailway: {
    width: trainColumns.railway,
  },
  tableEvent: {
    width: trainColumns.event,
  },
  tableDirection: {
    width: trainColumns.direction,
  },
  tableLocomotives: {
    width: trainColumns.locomotives,
  },
  tableWagons: {
    width: trainColumns.wagons,
  },
  tableContainers: {
    width: trainColumns.containers,
  },
  boldText: {
    fontWeight: "500",
  },
  statusText: {
    fontWeight: "500",
    borderRadius: "2px",
    backgroundColor: "lightGray",
    padding: "8px",
  },
  inputQuantity2: {
    padding: 8,
    width: 140,
    marginRight: 18,
  },
  editButton: {
    backgroundColor: "transparent"
  },
};

const TrainSequence = (props) => {
  const {
    classes,
    dispatch,
    section,
    tabIndex,
    openFromTab,
    trainMainEventData,
    language,
    tab,
    log,
    activeLogDetailsTab
  } = props;

  const selectedRailcarId = tab?.selectedRailcarId;

  // CSV Upload Manifest
  const [manifestFile, setManifestFile] = React.useState("");
  const inputFile = React.useRef(null);

  const handleFileUpload = e => {
    const { files } = e.target;
    if (files && files.length) {
      const filename = files[0].name;

      var parts = filename.split(".");
      const fileType = parts[parts.length - 1];
      console.log("fileType", fileType); //ex: zip, rar, jpg, svg etc.

      setManifestFile(files[0]);
    }
  };

  const onButtonClick = () => {
    inputFile.current.click();
  };

  // Event Details (Left Sidebar)
  const [eventTrainId, setEventTrainId] = React.useState("");
  const [eventDetectionType, setEventDetectionType] = React.useState();
  const [eventYardEventType, setEventYardEventType] = React.useState();
  const [eventCurrentStatus, setEventCurrentStatus] = React.useState("");
  const [eventTrainDateTime, setZoneTrainDateTime] = React.useState("");
  const [eventRiskLevel, setEventRiskLevel] = React.useState(0);
  // Scheduled Time State Placeholder
  // Risk Level State Placeholder
  const [trainComments, setTrainComments] = React.useState();
  const [eventGroupId, setEventGroupId] = React.useState("");
  const [eventActiveStatus, setEventActiveStatus] = React.useState();

  // Greybox (TrainInfoDisplay) Logic
  const setSelectedRailcarId = (id) => {
    dispatch(updateSelectedRailcarId(section, tabIndex, id));
  };

  // Carousel & Railcar Data Table
  const [railcarData, setRailcarData] = React.useState([]);
  const [reverseRailcars, setReverseRailcars] = React.useState(false);
  const [railcars, setRailcars] = React.useState([]);
  const [containerData, setContainerData] = React.useState([]);

  const [isFetching, setIsFetching] = React.useState(true);

  // Look-up Values & DB Data
  const [lov, setLov] = React.useState();
  const [detectionOptions, setDetectionOptions] = React.useState([]);
  const [yardEventOptions, setYardEventOptions] = React.useState([]);
  const [currentStatusOptions, setCurrentStatusOptions] = React.useState([]);
  const [riskLevelOptions, setRiskLevelOptions] = React.useState([]);

  // Filter
  const [railcarFilter, setRailcarFilter] = React.useState(0);
  const [matchFilter, setMatchFilter] = React.useState("");

  // Edit Mode & Temporary Edit Data
  const [isEditMode, setIsEditMode] = React.useState(false);

  const [trainIdTmp, setTrainIdTmp] = React.useState("");
  const [trainDetectTypeTmp, setTrainDetectTypeTmp] = React.useState();
  const [trainYardEventTypeTmp, setTrainYardEventTypeTmp] = React.useState();
  const [trainCommentsTmp, setTrainCommentsTmp] = React.useState("");
  const [currentStatusTmp, setCurrentStatusTmp] = React.useState();
  const [riskLevelTmp, setRiskLevelTmp] = React.useState();


  // Attribute Constants
  const TRAIN_ATTR_RAIL_DETECT_TYPE = 286;
  const TRAIN_ATTR_YARD_EVENT_TYPE = 288;
  const TRAIN_ATTR_TRAIN_ID = 289;
  const TRAIN_ATTR_L_FLAG = 294;

  React.useEffect(() => {
    // TODO: validate that these are the correct lov's to load
    // for the train system.
    const loadLov = async () => {
      let lov = {
        294: await getLov(TRAIN_ATTR_L_FLAG),
        286: await getLov(TRAIN_ATTR_RAIL_DETECT_TYPE),
        288: await getLov(TRAIN_ATTR_YARD_EVENT_TYPE),
        status: await getLov("status"),
        riskLevel: await getLov("riskLevel"),
      };
      setLov(lov);
      setDetectionOptions(getOptionsFromLov(lov, TRAIN_ATTR_RAIL_DETECT_TYPE, language));
      setYardEventOptions(getOptionsFromLov(lov, TRAIN_ATTR_YARD_EVENT_TYPE, language));
      setCurrentStatusOptions(getOptionsFromLov(lov, "status", language));
      setRiskLevelOptions(getOptionsFromLov(lov, "riskLevel", language));
    };

    loadLov();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (trainMainEventData && Object.keys(trainMainEventData).length === 0) return

    // Side & Upper Bar
    setEventTrainId(trainMainEventData.complete?.attributes?.filter(a => a.id === 289)[0].value)
    setTrainIdTmp(trainMainEventData.complete?.attributes?.filter(a => a.id === 289)[0].value)

    // console.log('286286',trainMainEventData.complete.attributes.filter(a => a.id === 286)[0].value)
    setEventDetectionType(trainMainEventData.complete.attributes.filter(a => a.id === 286)[0].value)
    setEventYardEventType(trainMainEventData.complete.attributes.filter(a => a.id === 288)[0].value)
    setEventCurrentStatus(trainMainEventData.complete.status.id)
    setZoneTrainDateTime(trainMainEventData.complete.created_on)
    setEventRiskLevel(trainMainEventData.main.riskLevel)
    setTrainComments(trainMainEventData.complete.description ? trainMainEventData.complete.description : "-")
    setEventGroupId(trainMainEventData.id)
    setEventActiveStatus(trainMainEventData.complete.active)

    // Edit Section
    setIsEditMode(false)
    // TMP Values for Edit Fields
    setTrainIdTmp(trainMainEventData.complete?.attributes?.filter(a => a.id === 289)[0].value || "")
    setTrainDetectTypeTmp(trainMainEventData.complete.attributes.filter(a => a.id === 286)[0].value)
    setTrainYardEventTypeTmp(trainMainEventData.complete.attributes.filter(a => a.id === 288)[0].value)
    setCurrentStatusTmp(trainMainEventData.complete.status.id)
    setRiskLevelTmp(trainMainEventData.complete.risk_level)
    setTrainCommentsTmp(trainMainEventData.complete.description ? trainMainEventData.complete.description : "")

    // Selected Railcar
    setSelectedRailcarId(trainMainEventData.detections?.railcars[trainMainEventData.detections.railcars.length - 1]?.id)

    // Carousel
    let minifiedRailcars = trainMainEventData.detections?.railcars.map(r => {
      return minifyRailcar(r)
    }).sort((a, b) => a.sequenceNo - b.sequenceNo);

    setRailcars(minifiedRailcars)
    setIsFetching(false)

    let newRailcarId = findNextVisibleRailcar(selectedRailcarId, minifiedRailcars, railcarFilter, matchFilter);
    setSelectedRailcarId(newRailcarId);

    // Railcar Table
    const types = [171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185];
    let genRailcarData = [];
    let genCargoData = [];

    if (trainMainEventData?.detections?.railcars[0]) {
      types.forEach(t => {
        let dataSet = trainMainEventData?.detections?.railcars?.filter(r => r.attributes.filter(att => att.id === 283)[0].value === t);

        genRailcarData.push({
          railcarType: t,
          matched: dataSet.filter(rc => !unknownProfiles.includes(rc.profile.id)).length,
          unmatched: dataSet.filter(rc => unknownProfiles.includes(rc.profile.id)).length,
          total: dataSet.length,
        })
      })

      setRailcarData(genRailcarData)

      let contDataSet = trainMainEventData?.detections?.railcars?.filter(r => r.event_groups).map(c => c.event_groups).flat();

      genCargoData.push({
        railcarType: "Container",
        matched: contDataSet.filter(rc => !unknownProfiles.includes(rc.profile.id)).length,
        unmatched: contDataSet.filter(rc => unknownProfiles.includes(rc.profile.id)).length,
        total: contDataSet.length,
      })

      setContainerData(genCargoData)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trainMainEventData])

  React.useEffect(() => {
    let newRailcarId = findNextVisibleRailcar(selectedRailcarId, railcars, railcarFilter, matchFilter)
    setSelectedRailcarId(newRailcarId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [railcarFilter, matchFilter])

  React.useEffect(() => {
    // Trigger Spinner when changing tab
    setIsFetching(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab.eventGroupId])

  const findNextVisibleRailcar = (oldRailcarId, railcars, railcarFilter, matchFilter) => {
    if (!railcars) return null;
    if (!Array.isArray(railcars)) return null;
    if (railcars.length === 0) return null;

    // If we don't have any old railcar, setting found to true will cause the first
    // visible railcar to be used, which is what we want.
    let foundOldRailcar = !oldRailcarId;
    let firstVisibleRailcarId = null;
    let newRailcarId = null;
    for (let i = 0; i < railcars.length; i++) {
      let isCurrentRailcarVisible = isRailcarVisible(railcars[i], railcarFilter, matchFilter);
      if (!firstVisibleRailcarId && isCurrentRailcarVisible) {
        firstVisibleRailcarId = railcars[i].railcarId;
      }
      if (!foundOldRailcar) {
        if (railcars[i].railcarId === oldRailcarId) foundOldRailcar = true;
      }
      if (foundOldRailcar) {
        if (isCurrentRailcarVisible) {
          newRailcarId = railcars[i].railcarId;
          i = railcars.length;
        }
      }
    }
    if (!newRailcarId) newRailcarId = firstVisibleRailcarId;
    return newRailcarId;
  }

  const handleFiltering = (detectionType, railcarType) => {
    if (railcarFilter === railcarType && detectionType === matchFilter) {
      setMatchFilter("")
      setRailcarFilter(0)
    } else {
      setMatchFilter(detectionType)
      setRailcarFilter(railcarType)
    }
  }

  const handleSubmitEdit = () => {
    try {
      const new_attributes = []

      if (trainIdTmp) {
        new_attributes.push({
          id: TRAIN_ATTR_TRAIN_ID,
          value: trainIdTmp
        })
      }

      if (trainDetectTypeTmp) {
        new_attributes.push({
          id: TRAIN_ATTR_RAIL_DETECT_TYPE,
          value: trainDetectTypeTmp
        })
      }

      if (trainYardEventTypeTmp) {
        new_attributes.push({
          id: TRAIN_ATTR_YARD_EVENT_TYPE,
          value: trainYardEventTypeTmp
        })
      }

      putTrain(eventGroupId, new_attributes)
      setTimeout(() => {
        dispatch(
          updateOneLog(
            section,
            tabIndex,
            openFromTab,
            log.id
          )
        );

      }, 200)
      setIsEditMode(false)

    } catch (error) {
      console.log(error)
    }
  }

  async function putTrain(id, data) {

    await fetchPut(
      `event_groups/${id}`,
      {
        "active": eventActiveStatus,
        "attributes": data,
        "description": trainCommentsTmp ? trainCommentsTmp : "",
        "risk_level": riskLevelTmp,
        "status": currentStatusTmp,
      }
    );
  }


  return (
    <Grid container
      direction="column"
      wrap="nowrap"
      className={`mainContent ${classes.carouselContainer}`}>
      {!isFetching ? <>
        <div className={classes.dataSidebar}>
          <div className={classes.dataItem} onClick={onButtonClick}>
            <span style={{ display: "flex", alignItems: "center" }}>
              <input
                style={{ display: "none" }}
                ref={inputFile}
                onChange={handleFileUpload}
                type="file"
              />
              <CompareManifest />
              <span className={classes.actionText} style={{ paddingLeft: "4px" }}>Compare Manifest</span>
            </span>
          </div>
          <div style={{ width: "140px", display: "flex", justifyContent: "flex-end" }}>
            {
              isEditMode ?
                <div style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
                  <Button className={classes.editButton} onClick={() => handleSubmitEdit()}>
                    <img src={images.save} alt="edit"></img>
                  </Button>
                  <CloseIcon closeFunction={() => setIsEditMode(false)} />
                </div>
                :
                <Button className={classes.editButton} onClick={() => { setIsEditMode(true) }}><img src={images.edit_vmi} alt="edit"></img></Button>
            }
          </div>
          <div className={classes.dataItem}>
            {
              isEditMode ?
                <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
                  <Checkbox
                    color="primary"
                    onChange={e => setEventActiveStatus(!eventActiveStatus)}
                    checked={eventActiveStatus}
                  />
                  <span className={classes.boldText}>Active</span>
                </div>
                :
                <>
                  <span className={classes.boldText}>Active:</span>
                  <span className={classes.black54}>{eventActiveStatus ? "Yes" : "No"}</span>
                </>

            }
          </div>
          <div className={classes.dataItem}>
            <span className={classes.boldText}>{I18n.get("train_id")}:</span>
            {
              isEditMode ?
                <input type="text" className={classes.inputQuantity2} value={trainIdTmp} onChange={(e) => { setTrainIdTmp(e.target.value) }}></input>
                :
                <span className={classes.black54}>{eventTrainId}</span>
            }
          </div>
          <div className={classes.dataItem}>
            <span className={classes.boldText}>Rail Detection Type:</span>
            {
              isEditMode ?
                <div>
                  <div style={{ width: 140, display: "inline-flex" }}>
                    <CustomSelect
                      name={"type"}
                      value={trainDetectTypeTmp}
                      noSort={true}
                      options={detectionOptions}
                      onChange={(e) => { setTrainDetectTypeTmp(e.target.value); }}
                    />
                  </div>
                </div>
                :
                <span className={classes.black54}>{detectionOptions[0] && eventDetectionType ? detectionOptions?.filter(d => d.id === eventDetectionType)[0].name : "-"}</span>
            }
          </div>
          <div className={classes.dataItem}>
            <span className={classes.boldText}>Yard Event Type:</span>
            {
              isEditMode ?
                <div>
                  <div style={{ width: 140, display: "inline-flex" }}>
                    <CustomSelect
                      name={"type"}
                      value={trainYardEventTypeTmp}
                      noSort={true}
                      options={yardEventOptions}
                      onChange={(e) => { setTrainYardEventTypeTmp(e.target.value); }}
                    />
                  </div>
                </div>
                :
                <span className={classes.black54}>{yardEventOptions[0] && eventYardEventType ? yardEventOptions?.filter(d => d.id === eventYardEventType)[0].name : "-"}</span>
            }
          </div>
          <div className={classes.dataItem}>
            <span className={classes.boldText}>{I18n.get("status")}:</span>
            {
              isEditMode ?
                <div>
                  <div style={{ width: 140, display: "inline-flex" }}>
                    <CustomSelect
                      name={"type"}
                      value={currentStatusTmp}
                      noSort={true}
                      options={currentStatusOptions}
                      onChange={(e) => { setCurrentStatusTmp(e.target.value); }}
                    />
                  </div>
                </div>
                :
                <span className={classes.black54}>{lov?.status?.filter(s => s.id === eventCurrentStatus)[0][`name_${language}`]}</span>
            }
          </div>
          <div className={classes.dataItem}>
            <span className={classes.boldText}>{I18n.get("profiles_dateTime")}:</span> <span className={classes.black54}>{eventTrainDateTime ? generateDate(eventTrainDateTime) : "-"}</span>
          </div>
          <div className={classes.dataItem}>
            <span className={classes.boldText}>Scheduled Time:</span>
            <span className={classes.black54}>{"-"}</span>
          </div>
          <div className={classes.dataItem}>
            <span className={classes.boldText}>Risk Level:</span>
            {
              isEditMode ?
                <div>
                  <div style={{ width: 140, display: "inline-flex" }}>
                    <CustomSelect
                      name={"type"}
                      value={riskLevelTmp}
                      noSort={true}
                      options={riskLevelOptions}
                      onChange={(e) => { setRiskLevelTmp(e.target.value); }}
                    />
                  </div>
                </div>
                :
                <span className={classes.black54}>{eventRiskLevel}</span>
            }
          </div>
          <div className={classes.dataItem}>
            <span className={classes.boldText}>Comments:</span>
            {
              isEditMode ?
                <input type="text" className={classes.inputQuantity2} value={trainCommentsTmp} onChange={(e) => { setTrainCommentsTmp(e.target.value) }}></input>
                :
                <span className={classes.black54}>{trainComments}</span>
            }
          </div>
          <div className={classes.dataItem}>
            <EventsDialog
              eventGroupId={eventGroupId}
              disabled={!eventGroupId ? true : false}
            />
          </div>
          {railcars && railcars[0] ?
            <div className={classes.dataItem} style={{ width: "24px" }}>
              <CsvExportDialog
                section={"train"}
                title={eventGroupId}
                railcarData={trainMainEventData.detections?.railcars}
                trainId={eventTrainId}
                trainYardEventType={yardEventOptions[0] && eventYardEventType ? yardEventOptions?.filter(d => d.id === eventYardEventType)[0].name : "-"}
                trainComments={trainComments ? trainComments : "-"}
                columns={[{ name: "Train ID" }, { name: "Date & Time" }, { name: "Profile Name" }, { name: "Sequence No." }, { name: "Container Position" }, { name: "Profile Type" }, { name: "Railcar Type" }, { name: "Yard Event Type" }, { name: "Comments" }]} />
            </div>
            : null}
        </div>
        <div className={classes.dataMain}>
          <div className={classes.trainTrackContainer}>
            <div className={classes.railcarDataTable}>
              <div className={classes.rcColumn}>
                <div className={`${classes.headerRow}`}>{I18n.get("matched")}</div>
                <div className={`${classes.headerRow}`}>{I18n.get("unmatched")}</div>
                <div className={`${classes.headerRow}`}>Total</div>
              </div>
              <div className={classes.rcColumn}>
                <div className={`${classes.headerColTotal} ${classes.headerColumn}`}><span className={classes.boldText}>{"Total"}</span></div>
                <div className={`${classes.headerColTotal} ${classes.actionText} ${matchFilter === "matched" && railcarFilter === 0 ? classes.matchFilter : ""}`} onClick={() => handleFiltering("matched", 0)}>{railcarData.reduce((pV, cV) => pV + cV.matched, 0)}</div>
                <div className={`${classes.headerColTotal} ${classes.actionText} ${matchFilter === "unmatched" && railcarFilter === 0 ? classes.matchFilter : ""}`} onClick={() => handleFiltering("unmatched", 0)}>{railcarData.reduce((pV, cV) => pV + cV.unmatched, 0)}</div>
                <div className={`${classes.headerColTotal} ${classes.actionText}`} onClick={() => handleFiltering("", 0)}>{railcarData.reduce((pV, cV) => pV + cV.total, 0)}</div>
              </div>
              {railcarData.map((r, i) => {
                return r.total > 0 ?
                  <div key={i} className={`${classes.rcColumn} `} >
                    <div className={`${classes.rcEntry} ${classes.headerColumn}`}>
                      <span className={classes.railcarName}>{returnRailcarName(r.railcarType)}</span>
                      <div className={classes.trainSvgIcon}><RailcarIcon type={r.railcarType} /></div>
                    </div>
                    <div className={`${classes.rcEntry} ${classes.actionText} ${matchFilter === "matched" && railcarFilter === r.railcarType ? classes.matchFilter : ""}`} onClick={() => handleFiltering("matched", r.railcarType)}>{r.matched}</div>
                    <div className={`${classes.rcEntry} ${classes.actionText} ${matchFilter === "unmatched" && railcarFilter === r.railcarType ? classes.matchFilter : ""}`} onClick={() => handleFiltering("unmatched", r.railcarType)}>{r.unmatched}</div>
                    <div className={`${classes.rcEntry} ${classes.actionText} ${matchFilter === "" && railcarFilter === r.railcarType ? classes.matchFilter : ""}`} onClick={() => handleFiltering("", r.railcarType)}>{r.total}</div>
                  </div>
                  : null
              })}
              <div className={classes.rcLastCol}></div>
              {containerData.map((r, i) => {
                return <div key={i} className={`${classes.rcColumn} ${i === 0 ? classes.rcColumnSpecial : ""}`}>
                  <div className={`${classes.rcEntry} ${classes.headerColumn}`}>
                    <span className={classes.railcarName}>{r.railcarType}</span>
                    <div className={classes.trainSvgIcon}><RailcarIcon type={r.railcarType} /></div>
                  </div>
                  <div className={`${classes.rcEntry} ${classes.actionText} ${matchFilter === "matched" && railcarFilter === r.railcarType ? classes.matchFilter : ""}`} onClick={() => handleFiltering("matched", r.railcarType)}>{r.matched}</div>
                  <div className={`${classes.rcEntry} ${classes.actionText} ${matchFilter === "unmatched" && railcarFilter === r.railcarType ? classes.matchFilter : ""}`} onClick={() => handleFiltering("unmatched", r.railcarType)}>{r.unmatched}</div>
                  <div className={`${classes.rcEntry} ${classes.actionText} ${matchFilter === "" && railcarFilter === r.railcarType ? classes.matchFilter : ""}`} onClick={() => handleFiltering("", r.railcarType)}>{r.total}</div>
                </div>
              })}
              <div className={classes.rcLastCol}></div>
            </div>
          </div>
          <div className={classes.trainDisplayPanels} >
            <TrainInfoDisplay
              section={section}
              tabIndex={tabIndex}
              openFromTab={openFromTab}
              selectedRailcarId={selectedRailcarId}
              activeLogDetailsTab={activeLogDetailsTab}
              log={log}
            />
            <TrainCarousel
              railcars={railcars}
              setRailcars={setRailcars}
              reverseRailcars={reverseRailcars}
              setReverseRailcars={setReverseRailcars}
              setSelectedRailcarId={setSelectedRailcarId}
              selectedRailcarId={selectedRailcarId}
              railcarFilter={railcarFilter}
              matchFilter={matchFilter}
            />
          </div>
        </div>
      </>
        : <div style={{ width: "100%", display: "flex", justifyContent: "center", paddingTop: "200px" }}>
          <CircularProgress />
        </div>}
    </Grid>
  );
};

const mapStateToProps = (state) => {
  return {
    language: get(state, ["user", "language"]),
    user: state.user,
    userRole: get(state, ["user", "role"]),
    solutionsAccess: get(state, ["user", "solutionsAccess"]),
    permissions: get(state, ["user", "permissions"]),
  };
};

export default withRouter(
  connect(mapStateToProps)(withStyles(styles)(TrainSequence))
);
